export default {
  LOCATIONS: ({ limit = 30, offset, location }) =>
  `/carrier/location?limit=${limit}&offset=${offset * limit}` +
    `${location ? `&location=${location}` : ''}`
}
